function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.8 16V3.2C12.8 1.398 14.233 0 16 0c1.767 0 3.2 1.398 3.2 3.2V16c0 1.802-1.433 3.2-3.2 3.2a3.178 3.178 0 01-3.2-3.2zM16 32a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4z",
  fill: "currentColor"
})));